
import axios from "axios";
import baseUrl from "./baseURL";
import {getCsrfToken, ensureCsrfToken, CSRF_HEADER_NAME} from "./csrf";

const api = axios.create({
    baseURL: baseUrl(),
    timeout: 60000 * 5,
    withCredentials: true
});

api.interceptors.request.use(async (config) => {
    const nextConfig = {...config};
    nextConfig.headers = nextConfig.headers || {};
    nextConfig.headers["Content-type"] = "application/json";

    const accessToken = sessionStorage.getItem('access');
    if (accessToken) {
        nextConfig.headers["Authorization"] = `Bearer ${accessToken}`;
    }

    const method = (nextConfig.method || 'get').toLowerCase();
    const needsCsrf = ['post', 'put', 'patch', 'delete'].includes(method);

    if (needsCsrf) {
        let csrfToken = getCsrfToken();
        if (!csrfToken) {
            csrfToken = await ensureCsrfToken();
        }
        if (csrfToken) {
            nextConfig.headers[CSRF_HEADER_NAME] = csrfToken;
        }
    }

    return nextConfig;
}, (error) => Promise.reject(error));

export default api;


